import React, { useCallback, useEffect, useState } from 'react'
import './App.css'
import { Redirect } from 'react-router-dom'
import Axios from 'axios'
import TopBarProgress from 'react-topbar-progress-indicator'
import { v4 as uuidv4 } from 'uuid'
import { FaWhatsapp, FaFacebook, FaLinkedin } from 'react-icons/fa'
import { SiX } from 'react-icons/si'
import { HiOutlineMail } from 'react-icons/hi'
import { BiMenu, BiCopy, BiCheck } from 'react-icons/bi'
import MyRecruits from './Wallet'
import SideNavAff from './layouts/SideNavAff'
import Header from './layouts/Header'
import { API_URL } from './config'

const uuid = uuidv4().replace('-', '').slice(1, 12)

const SHARE_TEXT =
  "Organizing events? You need to check out #Karamale. Sell tickets, track revenue, and see real-time sales - all in one place.\n\nI'm part of their affiliate program because it works. See for yourself 👉"

const REFERRAL_CSS = `
  .aff-ref { background: #fff; border: 1px solid #e4e7ec; border-radius: 10px; padding: 16px 18px; margin-top: 12px; }
  .aff-ref-top { display: flex; align-items: baseline; justify-content: space-between; flex-wrap: wrap; gap: 6px; }
  .aff-ref h6 { font-size: 16px; font-weight: 700; margin: 0; }
  .aff-ref-count { font-size: 13px; color: #667085; }
  .aff-ref-sub { font-size: 14px; color: #667085; margin: 4px 0 12px; }
  .aff-ref-row { display: flex; gap: 8px; flex-wrap: wrap; }
  .aff-ref-input { flex: 1 1 260px; min-width: 0; height: 40px; border: 1px solid #e4e7ec; border-radius: 8px; padding: 0 12px; font-size: 14px; background: #f6f7f9; color: #1f2933; }
  .aff-ref-copy { height: 40px; min-width: 104px; border: 0; border-radius: 8px; background: #dc3545; color: #fff; font-weight: 700; font-size: 14px; padding: 0 16px; display: inline-flex; align-items: center; justify-content: center; gap: 6px; cursor: pointer; }
  .aff-ref-copy:disabled { opacity: .6; cursor: wait; }
  .aff-ref-share { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin-top: 12px; font-size: 13px; color: #667085; }
  .aff-share { width: 36px; height: 36px; border: 1px solid #e4e7ec; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: #1f2933; background: #fff; text-decoration: none; }
  .aff-share:hover { background: #f6f7f9; color: #dc3545; text-decoration: none; }
  .aff-ref button:focus-visible, .aff-ref a:focus-visible, .aff-ref input:focus-visible { outline: 2px solid #dc3545; outline-offset: 2px; }
`

/* ------------------------------------------------------------------ */
/* Referral link card                                                  */
/* ------------------------------------------------------------------ */
const ReferralCard = ({ affiliateId, affiliateCount, generating, onGenerate }) => {
  const [copied, setCopied] = useState(false)
  const link = affiliateId ? `${API_URL}?affiliateid=${affiliateId}` : ''

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link)
      setCopied(true)
      setTimeout(() => setCopied(false), 3000)
    } catch (e) {
      console.log(e)
    }
  }

  const enc = encodeURIComponent
  const shares = [
    {
      label: 'Share on WhatsApp',
      href: `https://wa.me/?text=${enc(`${SHARE_TEXT} ${link}`)}`,
      icon: <FaWhatsapp size={18} />,
    },
    {
      label: 'Share on X',
      href: `https://twitter.com/intent/tweet?text=${enc(SHARE_TEXT)}&url=${enc(link)}`,
      icon: <SiX size={15} />,
    },
    {
      label: 'Share on Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${enc(link)}`,
      icon: <FaFacebook size={18} />,
    },
    {
      label: 'Share on LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(link)}`,
      icon: <FaLinkedin size={18} />,
    },
    {
      label: 'Share by email',
      href: `mailto:?subject=${enc('Sell your event tickets on Karamale')}&body=${enc(`${SHARE_TEXT} ${link}`)}`,
      icon: <HiOutlineMail size={19} />,
    },
  ]

  return (
    <div className="aff-ref">
      <style>{REFERRAL_CSS}</style>
      <div className="aff-ref-top">
        <h6>Your referral link</h6>
        <span className="aff-ref-count">
          {affiliateCount} {Number(affiliateCount) === 1 ? 'organiser has' : 'organisers have'}{' '}
          joined through your link
        </span>
      </div>

      {link ? (
        <>
          <p className="aff-ref-sub">
            Share this link with event organisers. You earn when their online ticket sales come in.
          </p>
          <div className="aff-ref-row">
            <input
              className="aff-ref-input"
              type="text"
              readOnly
              value={link}
              aria-label="Your referral link"
              onFocus={(e) => e.target.select()}
            />
            <button type="button" className="aff-ref-copy" onClick={copy}>
              {copied ? <BiCheck size={18} /> : <BiCopy size={17} />}
              {copied ? 'Copied' : 'Copy link'}
            </button>
          </div>
          <div className="aff-ref-share">
            <span>Share</span>
            {shares.map((s) => (
              <a
                key={s.label}
                className="aff-share"
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                title={s.label}
                aria-label={s.label}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </>
      ) : (
        <>
          <p className="aff-ref-sub">
            You don't have a referral link yet. Generate one to start earning from the organisers
            you refer.
          </p>
          <button type="button" className="aff-ref-copy" onClick={onGenerate} disabled={generating}>
            {generating ? 'Generating...' : 'Generate my link'}
          </button>
        </>
      )}
    </div>
  )
}

/* ------------------------------------------------------------------ */
/* Dashboard                                                           */
/* ------------------------------------------------------------------ */
const isMobileWidth = () => window.innerWidth <= 768

const Dashboard = () => {
  const [isMobile, setIsMobile] = useState(isMobileWidth())
  const [collapsed, setCollapsed] = useState(isMobileWidth())
  const [affiliateId, setAffiliateId] = useState('')
  const [affiliateCount, setAffiliateCount] = useState(0)
  const [generating, setGenerating] = useState(false)

  const partnername = localStorage.getItem('partnername')
  const partnerid = localStorage.getItem('partnerid')
  const accounttype = localStorage.getItem('accounttype')

  // keep the layout in sync with the window; auto-collapse only when entering mobile
  useEffect(() => {
    const onResize = () => {
      const mobile = isMobileWidth()
      setIsMobile(mobile)
      if (mobile) setCollapsed(true)
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    document.title = `${partnername} - Affiliate program`

    if (!localStorage.getItem('customid')) {
      localStorage.setItem('customid', partnerid + '' + uuid)
    }

    let cancelled = false

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=RECRUITS&subquery=AFFILIATECOUNT&partnerid=${partnerid}`,
      { withCredentials: true },
    )
      .then((response) => {
        if (cancelled) return
        setAffiliateCount(response.data.val == 1 ? response.data.affiliateCount : 0)
      })
      .catch((error) => console.log(error))

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=PARTNERDETAILS&partnerid=${partnerid}`,
      { withCredentials: true },
    )
      .then((response) => {
        if (!cancelled) setAffiliateId(response.data.affiliateid ?? '')
      })
      .catch((error) => console.log(error))

    return () => {
      cancelled = true
    }
  }, [partnername, partnerid])

  const generateLink = useCallback(() => {
    const customId = localStorage.getItem('customid')
    setGenerating(true)
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=SAVEAFFILIATEID&partnerid=${encodeURIComponent(
        partnerid,
      )}&affiliateid=${encodeURIComponent(customId)}`,
      { withCredentials: true },
    )
      .then((response) => setAffiliateId(response.data.affiliateid ?? ''))
      .catch((error) => console.log(error))
      .finally(() => setGenerating(false))
  }, [partnerid])

  const toggleSidebar = () => setCollapsed((c) => !c)

  if (partnername === null) {
    return <Redirect to="/login" />
  }

  return (
    <div className="view">
      {generating && <TopBarProgress />}
      <Header />

      {accounttype === 'partner' && <SideNavAff collapsed={collapsed} onToggle={toggleSidebar} />}

      <div
        className="main-content"
        style={{
          marginTop: 60,
          marginLeft: isMobile ? '0px' : collapsed ? '60px' : '240px',
        }}
      >
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={toggleSidebar} />
        )}

        {isMobile && collapsed && (
          <label className="mobile-toggle" onClick={toggleSidebar}>
            <BiMenu size={25} />
          </label>
        )}

        <MyRecruits
          referral={
            <ReferralCard
              affiliateId={affiliateId}
              affiliateCount={affiliateCount}
              generating={generating}
              onGenerate={generateLink}
            />
          }
        />
      </div>
    </div>
  )
}

export default Dashboard
